export class SourceItem {
  public id?: string = '';
  public location = '';
  public created_by = '';
  public last_updated_by = '';
  public created_ts: number = null;
  public last_updated_ts: number = null;
}
